export type DetectedOs = "windows" | "mac" | "linux" | "unknown";

/**
 * Recommend desktop downloads only on a recognized desktop OS. Phones,
 * tablets, and unknown browsers get the web app; explicit /download visits
 * still list every installer.
 */
export function detectOs(userAgent: string, maxTouchPoints = 0): DetectedOs {
  const ua = userAgent.toLowerCase();
  if (/android|iphone|ipad|ipod|mobile/.test(ua)) return "unknown";
  // iPadOS can request desktop sites with a Macintosh user agent.
  if (ua.includes("mac") && maxTouchPoints > 1) return "unknown";
  if (ua.includes("win")) return "windows";
  if (ua.includes("mac")) return "mac";
  if (ua.includes("linux") && !ua.includes("android")) return "linux";
  return "unknown";
}
